<!--
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: ldx
 * @LastEditTime: 2024-04-30 16:31:18
 * @FilePath: \dev_2.0\src\views\home\childComp\Layout-main.vue
 * @Description:
-->
<template>
  <div :class="screenWidth > 765 ? 'product-pc' : 'product-mb'">
    <home-title :title="`产品中心`" :screenWidth="screenWidth" :info="screenWidth > 765
      ? '深耕智慧教育行业，打造全场景闭环式智慧教育体系'
      : ''
    "></home-title>
    <div class="pc-box-product" v-if="screenWidth > 765">
      <div>
        <div v-for="(item, index) in productListPc" :key="index" class="pc-row row">
          <div v-for="(el, indexs) in item" :key="indexs" :class="el.class" class="row-item" @click="
    goPage(`${el.path}?type=${el.flag || ''}&id=${el.id || ''}`);
  saveTabInStore(el);
  ">
            <div class="img">
              <img :src="el.url" alt="" class="images-scare" />
            </div>
            <div class="title">{{ el.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-product" v-else>
      <div v-for="(item, index) in productListMb" :key="index" @click="
    goPage(`${item.path}?type=${item.flag || ''}&id=${item.id || ''}`);
  saveTabInStore(item);
  ">
        <div :class="item.class" v-if="item.class">
          <img :src="item.url" alt="" v-if="item.url" class="img-style" />
          <div v-if="item.title" class="font-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <home-title :title="`服务支持`" :screenWidth="screenWidth" info="以用户为中心"></home-title>
    <div class="pc-serve" v-if="screenWidth > 765">
      <div v-for="(item, index) in serverList" :key="index" class="box-outer" :class="item.classMg"
        @click="goPage(item.path)">
        <img :src="item.url" alt="" :class="item.class" class="" />
        <div class="info-box">
          <div class="title">{{ item.title }}</div>
          <div class="info">{{ item.info }}</div>
        </div>
      </div>
    </div>
    <div class="mb-serve" v-else>
      <div v-for="(item, index) in serverList" :key="index" class="box-outer" :class="item.class"
        @click="goPage(item.path)">
        <div class="info-box">
          <div class="title">{{ item.title }}</div>
          <div class="info">{{ item.mbInfo1 }}</div>
          <div class="info">{{ item.mbInfo2 }}</div>
        </div>
        <img :src="item.url" alt="" :class="item.mbClass" />
      </div>
    </div>

    <home-title :title="`案例专区`" :screenWidth="screenWidth" info="安道教育助力数千所学校完成智慧校园升级"></home-title>
    <div class="pc-example mb-example">
      <div :class="screenWidth > 765 ? 'tab-box' : 'tab-box-mb'">
        <div v-for="(item, index) in exampleList" :key="index" :class="{
    'tab-item': screenWidth > 765,
    'tab-item-mb': screenWidth < 765,
    activeTab: exampleCurrentTab
      ? item.tab == exampleCurrentTab.tab
      : '',
  }" @click="changeExampleTab(item)">
          {{ item.tab }}
        </div>
      </div>
      <img @click="goImgPage" :src="exampleCurrentTab
      ? exampleCurrentTab.url
      : require('@/assets/images/image-v2.0.0/other.png')
    " alt="" :class="screenWidth > 765 ? 'hover-img' : 'hover-img-mb'" />
    </div>

    <home-title :title="'新闻中心'" :screenWidth="screenWidth" info="汇聚安道教育品牌资讯，及时呈现最全面的资讯动态"></home-title>
    <div class="news">
      <div class="news-inner">
        <div class="title">
          <div class="l-title">关注AMDOX最新动向</div>
          <div class="r-title">新闻资讯</div>
        </div>
        <div class="content" v-if="screenWidth > 765">
          <div class="pc-shadow" v-if="newList[0]" @click="goDetail(newList[0].id, 0)">
            <img :src="showLatestNews('spicPath')" alt="" class="pc-img-content wow fadeInDown" />
            <div class="shadow-box">
              <div class="shadow-l">
                <div class="day">{{ showLatestNews("day") }}</div>
                <div class="date">{{ showLatestNews("creatTime") }}</div>
              </div>
              <div class="shadow-r">
                <div class="pro-name">{{ showLatestNews("title") }}</div>
                <!-- <div class="pro-info">
                  {{ showLatestNews("content") }}
                </div> -->
              </div>
            </div>
          </div>
          <ul class="pc-news-list">
            <li v-for="(item, itemIndex) in newList" :key="item.id" @click="goDetail(item.id, itemIndex)">
              <div class="info">
                {{ item.title }}
              </div>
              <div>{{ timeGet(item.creatTime) }}</div>
            </li>
            <li @click="goNewsListPage">
              <div class="more">
                <span> 查看更多</span><img src="@/assets/images/image-v2.0.0/next.png" alt="" />
              </div>
              <div></div>
            </li>
          </ul>
        </div>
        <div class="mb-content" v-else>
          <div class="news-inner">
            <div class="mb-shadow" v-if="newList[0]" @click="goDetail(newList[0].id, 0)">
              <div class="shadow-box">
                <div class="shadow-l">
                  <div class="day">{{ showLatestNews("day") }}</div>
                  <div class="date">{{ showLatestNews("creatTime") }}</div>
                </div>
                <div class="shadow-r">
                  <div class="pro-name">{{ showLatestNews("title") }}</div>
                </div>
              </div>
            </div>
            <img :src="showLatestNews('spicPath')" alt="" class="mb-img-content" />
          </div>
          <ul class="mb-news-list">
            <li v-for="(item, itemIndex) in newList" :key="item.id" @click="goDetail(item.id, itemIndex)">
              <div class="info">
                {{ item.title }}
              </div>
              <div>{{ timeGet(item.creatTime) }}</div>
            </li>
            <li @click="goNewsListPage">
              <div class="more">
                查看更多<img class="arrow-l" src="@/assets/images/image-v2.0.0/next.png" alt="" />
              </div>
              <div></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeTitle from "./HomeTitle/HomeTitle";
import { getNewsByPage } from "@/network/newApi";
export default {
  props: ["goodsList", "screenWidth"],
  components: {
    HomeTitle,
  },
  data() {
    return {
      exampleCurrentTab: null,
      productListMb: [
        {
          title: "教育信息化设备",
          url: require("@/assets/images/image-v2.0.0/Mobile_home_img1.png"),
          class: "r1-img",
        },

        {
          title: "智慧教育应用软件",
          url: require("@/assets/images/image-v2.0.0/Mobile_home_img2.png"),
          class: "r-2-img",
        },
        {
          title: "教育信息化解决方案",
          url: require("@/assets/images/image-v2.0.0/Mobile_home_img3.png"),
          class: "r-2-img",
        },
        {
          title: "配件专区",
          url: require("@/assets/images/image-v2.0.0/Mobile_home_img4.png"),
          class: "l2-img",
        },
      ],
      productListPc: [
        [
          {
            title: "教育信息化设备",
            url: require("@/assets/images/image-v2.0.0/1.png"),
            class: "col-8",
          },
          {
            title: "智慧教育应用软件",
            url: require("@/assets/images/image-v2.0.0/2.png"),
            class: "col-4",
          },
        ],
        [
          {
            title: "教育信息化解决方案",
            url: require("@/assets/images/image-v2.0.0/3.png"),
            class: "col-6",
          },
          {
            title: "配件专区",
            url: require("@/assets/images/image-v2.0.0/4.png"),
            class: "col-6",
          },
        ],
      ],
      serverList: [
        {
          title: "培训中心",
          info: "提高教师现代化教学水平",
          mbInfo1: "提高教师",
          mbInfo2: "现代化教学水",
          mbClass: "img-1",
          url: require("@/assets/images/image-v2.0.0/5.png"),
          class: "img1",
          path: "/zh/trainList",
        },
        {
          title: "下载专区",
          info: "提供安道教育免费教学应用软件安全下载服务",
          mbInfo1: "提供安道教育",
          mbInfo2: "免费教学应用软件安全下载服务",
          mbClass: "img-2",
          url: require("@/assets/images/image-v2.0.0/6.png"),
          class: "img2",
          classMg: "marginClass",
          path: "/zh/download",
        },
        {
          title: "售后服务",
          info: "以用户为中心，全力做好服务保障工作",
          mbInfo1: "以用户为中心",
          mbInfo2: "全力做好服务保障工作",
          mbClass: "img-3",
          url: require("@/assets/images/image-v2.0.0/7.png"),
          class: "img3",
          path: "/zh/service",
        },
      ],
      exampleList: [
        {
          tab: "幼教",
          url: require("@/assets/images/image-v2.0.0/Home-anli-1.png"),
        },
        {
          tab: "K12",
          url: require("@/assets/images/image-v2.0.0/Home-anli-2.png"),
        },
        {
          tab: "高校职校",
          url: require("@/assets/images/image-v2.0.0/Home-anli-3.png"),
        },
        {
          tab: "其他",
          url: require("@/assets/images/image-v2.0.0/Home-anli-4.png"),
        },
      ],
      newList: [],
    };
  },
  created() {
    this.getNewsByPage();
    this.getTabList();
    this.getCaseTablist();
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  methods: {
    /**
     * @description: 获取案例中心的分类列表
     * @param {*}
     * @return {*}
     */
    async getCaseTablist() {
      let form = {
        id: 3,
        type: "case",
      };
      let data = await this.$store.dispatch("getOfficialNewsCategory", form);
      data.map((item) => {
        this.exampleList.map((el) => {
          if (el.tab == item.newsCategoryName) {
            el.id = item.newsCategoryId;
            el.path = "/zh/caseList";
          }
        });
        this.exampleCurrentTab = this.exampleList[0];
      });
    },
    /**
     * @description: 获取产品中心tab
     * @param {*}
     * @return {*}
     */
    async getTabList() {
      let list = await this.$store.dispatch("getProductNavList");
      list.push({
        path: "/zh/parts",
        name: "配件专区",
        productCategoryId: "",
        type: "",
      });
      list.forEach((element) => {
        this.productListPc.forEach((item) => {
          item.forEach((innerItem) => {
            if (element.name == innerItem.title) {
              innerItem.path = element.path;
              innerItem.id =
                element.productCategoryId || element.productModuleId;
              innerItem.flag = element.flag;
              innerItem.name = element.name;
            }
          });
        });
        this.productListMb.map((el) => {
          if (element.name == el.title) {
            el.path = element.path;
            el.id = element.productCategoryId || element.productModuleId;
            el.flag = element.flag;
            el.name = element.name;
          }
        });
      });
    },
    changeExampleTab(item) {
      this.exampleCurrentTab = item;
    },
    goImgPage() {
      this.$router.push(
        `${this.exampleCurrentTab.path}?id=${this.exampleCurrentTab.id}`
      );
    },
    getNewsByPage() {
      let parmas = {
        pageNum: 1,
        pageSize: 5,
      };
      getNewsByPage(parmas, { type: 1 }).then((res) => {
        if (res.data.state == 1) {
          this.newList = res.data.data.list;
        }
      });
    },
    timeGet(time) {
      return time.split(" ")[0];
    },
    showLatestNews(type) {
      let text =
        this.newList[0] && this.newList[0][type] ? this.newList[0][type] : "";
      if (type == "creatTime") {
        let temp = text.split(" ")[0].split("-");
        text = `${temp[0]}-${temp[1]}`;
      }
      if (type == "day")
        text = Number(this.newList[0].creatTime.split(" ")[0].split("-")[2]);
      return text;
    },
    goNewsListPage() {
      this.$router.push("/zh/about/news/newList");
    },
    goDetail(id, index) {
      // let json = {
      //   list: null,
      //   index: null,
      // };
      // json.list = this.newList;
      // json.index = index;
      // this.$store.dispatch("saveNews", json);
      this.$store.dispatch("saveNews", this.newList)
      this.$router.push(`/zh/about/news/newsInfo?id=${id}`);
    },
    goPage(path) {
      this.$router.push(path);
    },
    saveTabInStore(nav) {
      console.log(nav);
      this.$store.dispatch("saveTabInStore", nav);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/Layout-main/Layout-main-mb.scss";
@import "../sass/Layout-main/Layout-main-pc.scss";
</style>